import Vue from 'vue'
import VueRouter from 'vue-router'
import EkycDashboard from '../views/EkycDashboard.vue'
import RekycDashboard from '../views/RekycDashboard.vue'

import ReportUploads from '../views/ReportUploads.vue'

import GoogleSso from '../components/GoogleSso.vue'
import ApDashboard from '../views/ApDashboard.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'sso',
    component: GoogleSso
  },

  {
    path: '/rekyc/dashboard',
    name: 'rekyc',
    component: RekycDashboard
  },
  {
    path: '/ekyc/dashboard',
    name: 'ekyc',
    component: EkycDashboard
  },
  {
    path: '/uploads',
    name: 'report upload',
    component: ReportUploads
  },
  {
    path: '/ap/dashboard',
    name: 'ap',
    component: ApDashboard
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
